var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/cup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M27 30.7499H25.5V30.3749C25.5 28.7249 24.15 27.3749 22.5 27.3749H19.125V23.9399C18.75 23.9849 18.375 23.9999 18 23.9999C17.625 23.9999 17.25 23.9849 16.875 23.9399V27.3749H13.5C11.85 27.3749 10.5 28.7249 10.5 30.3749V30.7499H9C8.385 30.7499 7.875 31.2599 7.875 31.8749C7.875 32.4899 8.385 32.9999 9 32.9999H27C27.615 32.9999 28.125 32.4899 28.125 31.8749C28.125 31.2599 27.615 30.7499 27 30.7499Z",
    fill: "#314DDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M8.27992 17.46C7.28992 17.085 6.41992 16.47 5.72992 15.78C4.33492 14.235 3.41992 12.39 3.41992 10.23C3.41992 8.07 5.11492 6.375 7.27492 6.375H8.11492C7.72492 7.17 7.49992 8.055 7.49992 9V13.5C7.49992 14.91 7.76992 16.245 8.27992 17.46Z",
    fill: "#314DDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M32.5797 10.23C32.5797 12.39 31.6647 14.235 30.2697 15.78C29.5797 16.47 28.7097 17.085 27.7197 17.46C28.2297 16.245 28.4997 14.91 28.4997 13.5V9C28.4997 8.055 28.2747 7.17 27.8847 6.375H28.7247C30.8847 6.375 32.5797 8.07 32.5797 10.23Z",
    fill: "#314DDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.5 3H13.5C10.185 3 7.5 5.685 7.5 9V13.5C7.5 19.305 12.195 24 18 24C23.805 24 28.5 19.305 28.5 13.5V9C28.5 5.685 25.815 3 22.5 3ZM22.26 12.675L21.33 13.815C21.18 13.98 21.075 14.31 21.09 14.535L21.18 16.005C21.24 16.905 20.595 17.37 19.755 17.04L18.39 16.5C18.18 16.425 17.82 16.425 17.61 16.5L16.245 17.04C15.405 17.37 14.76 16.905 14.82 16.005L14.91 14.535C14.925 14.31 14.82 13.98 14.67 13.815L13.74 12.675C13.155 11.985 13.41 11.22 14.28 10.995L15.705 10.635C15.93 10.575 16.2 10.365 16.32 10.17L17.115 8.94C17.61 8.175 18.39 8.175 18.885 8.94L19.68 10.17C19.8 10.365 20.07 10.575 20.295 10.635L21.72 10.995C22.59 11.22 22.845 11.985 22.26 12.675Z",
    fill: "#314DDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.4,
    d: "M22.2601 12.675L21.3301 13.815C21.1801 13.98 21.0751 14.31 21.0901 14.535L21.1801 16.005C21.2401 16.905 20.5951 17.37 19.7551 17.04L18.3901 16.5C18.1801 16.425 17.8201 16.425 17.6101 16.5L16.2451 17.04C15.4051 17.37 14.7601 16.905 14.8201 16.005L14.9101 14.535C14.9251 14.31 14.8201 13.98 14.6701 13.815L13.7401 12.675C13.1551 11.985 13.4101 11.22 14.2801 10.995L15.7051 10.635C15.9301 10.575 16.2001 10.365 16.3201 10.17L17.1151 8.93996C17.6101 8.17496 18.3901 8.17496 18.8851 8.93996L19.6801 10.17C19.8001 10.365 20.0701 10.575 20.2951 10.635L21.7201 10.995C22.5901 11.22 22.8451 11.985 22.2601 12.675Z",
    fill: "#314DDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.ef48303bc93709d7c3f36ca1839f837f.svg";
export { ForwardRef as ReactComponent };